import axios from 'axios';

export const getDropdownAkuns = async () => {
    return await axios.get(`${window._HOST}akuntan/akuns/dropdown`, {withCredentials: true});
}

export const getDropdownAkunsDebet = async () => {
    return await axios.get(`${window._HOST}akuntan/akuns/dropdownDebet`, {withCredentials: true});
}

export const getDropdownAkunsKredit = async () => {
    return await axios.get(`${window._HOST}akuntan/akuns/dropdownKredit`, {withCredentials: true});
}

export const getDropdownKodeAkun = async () => {
    return await axios.get(`${window._HOST}akuntan/akuns/dropdownKodeAkun`, {withCredentials: true});
}